import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f793d22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toolbar__content" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_3 = { class: "pe-5" }
const _hoisted_4 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title" }, "General Information", -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Search = _resolveComponent("Search")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.route.name == 'Bill-ManagementList')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_select, {
              modelValue: _ctx.searchForm.bill_status,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.bill_status) = $event)),
              placeholder: "Select",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_input, {
              clearable: "",
              modelValue: _ctx.searchForm.bill_text,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.bill_text) = $event)),
              placeholder: "Search invoice number / invoice type / description",
              style: {"width":"23vw"},
              "value-key": "name"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_el_icon, { class: "el-input__icon" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Search)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.route.name == 'monitorRiderDetail')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true)
  ]))
}